import { fullWidthStyles } from "components/components/FullWidthSection/style";
import styled from "styled-components";

export const StyledContent = styled.div`
  display: flex;
  align-items: stretch;
  ${fullWidthStyles};
  min-height: 400px;
`;
